const doc = [({"ko":({"adminConstantHotelChildrenSettingMealType":({"included":"있다", "notIncluded":"없음", "sameAsAdult":"성인과 동일"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;